import Dexie from 'dexie';
import { IAdminDashReports } from './../../shared/interfaces/admin-dash-reports';
import { IReportDetail } from '../../shared/interfaces/report-detail';
import { IUserInfo } from 'src/app/shared/interfaces/user-info';
import { ILearner } from 'src/app/shared/interfaces/learner';
import { IManager } from 'src/app/shared/interfaces/manager';
import { IAssessor } from 'src/app/shared/interfaces/assessor';
import { Injectable } from '@angular/core';
import { IHealthAndSafetyDashReports } from 'src/app/shared/interfaces/h-s-dash-reports';
import { IMilestone } from 'src/app/shared/interfaces/milestone';
import { IPotProgress } from 'src/app/shared/interfaces/potprogress';

@Injectable()
export class LocalDb extends Dexie {
  users: Dexie.Table<IUserInfo, string>;
  permission: Dexie.Table<number[], string>;
  learners: Dexie.Table<ILearner, string>;
  employers: Dexie.Table<any, string>;
  managers: Dexie.Table<IManager, string>;
  assessors: Dexie.Table<IAssessor, string>;
  favourites: Dexie.Table<IReportDetail, number>;
  favouriteLearner: Dexie.Table<any, string>;
  learnerSearch: Dexie.Table<any, string>;
  search: Dexie.Table<any, string>;
  searchHistory: Dexie.Table<any, string>;
  employerSearch: Dexie.Table<any, string>;
  staffSearch: Dexie.Table<any, string>;
  adminDashReports: Dexie.Table<IAdminDashReports, string>;
  smtDashReports: Dexie.Table<IAdminDashReports, string>;
  healthAndSafetyDashReports: Dexie.Table<IHealthAndSafetyDashReports, string>;
  milestones: Dexie.Table<IMilestone, string>;
  progress: Dexie.Table<IPotProgress, string>;
  attendance: Dexie.Table<any, string>;

  constructor() {
    super('LocalDb');

    this.version(1)
      .stores({
        users: '',
        learners: '++id, traineeId',
        employers: '++id, employerId, type',
        managers: '++id, userId',
        assessors: '++id, userId, assessorId',
        favourites: '',
        learnerSearch: '',
        employerSearch: '',
        staffSearch: '',
      })
      .upgrade(() => {
        // Upgrade handled by schema change
      });

    this.version(2)
      .stores({
        users: '',
        learners: '++id, traineeId',
        employers: '++id, employerId, type',
        managers: '++id, userId',
        assessors: '++id, userId, assessorId',
        favourites: '',
        learnerSearch: '',
        employerSearch: '',
        staffSearch: '',
      })
      .upgrade(() => {
        // Upgrade handled by schema change
      });

    this.version(3)
      .stores({
        users: '',
        learners: '++id, traineeId',
        employers: '++id, employerId, type',
        managers: '++id, userId',
        assessors: '++id, userId, assessorId',
        favourites: '',
        learnerSearch: '',
        employerSearch: '',
        staffSearch: '',
      })
      .upgrade(() => {
        // Upgrade handled by schema change
      });

    this.version(4)
      .stores({
        users: '',
        learners: '++id, traineeId',
        employers: '++id, employerId, type',
        managers: '++id, userId',
        assessors: '++id, userId, assessorId',
        favourites: '',
        learnerSearch: '',
        employerSearch: '',
        staffSearch: '',
      })
      .upgrade(() => {
        // Upgrade handled by schema change
      });

    this.version(5)
      .stores({
        users: '',
        learners: '++id, traineeId',
        employers: '++id, employerId, type',
        managers: '++id, userId',
        assessors: '++id, userId, assessorId',
        favourites: '',
        learnerSearch: '',
        employerSearch: '',
        staffSearch: '',
        adminDashReports: '',
      })
      .upgrade(() => {
        // Upgrade handled by schema change
      });

    this.version(6)
      .stores({
        users: '',
        learners: '++id, traineeId',
        employers: '++id, employerId, type',
        managers: '++id, userId',
        assessors: '++id, userId, assessorId',
        favourites: '',
        learnerSearch: '',
        employerSearch: '',
        staffSearch: '',
        adminDashReports: '',
        smtDashReports: '',
      })
      .upgrade(() => {
        // Upgrade handled by schema change
      });

    this.version(7)
      .stores({
        users: '',
        learners: '++id, traineeId',
        employers: '++id, employerId, type',
        managers: '++id, userId',
        assessors: '++id, userId, assessorId',
        favourites: '',
        learnerSearch: '',
        employerSearch: '',
        staffSearch: '',
        adminDashReports: '',
        smtDashReports: '',
        healthAndSafetyDashReports: '',
      })
      .upgrade(() => {
        // Upgrade handled by schema change
      });

    this.version(8)
      .stores({
        users: '',
        learners: '++id, traineeId',
        employers: '++id, employerId, type',
        managers: '++id, userId',
        assessors: '++id, userId, assessorId',
        favourites: '',
        learnerSearch: '',
        employerSearch: '',
        staffSearch: '',
        adminDashReports: '',
        smtDashReports: '',
        healthAndSafetyDashReports: '',
        learnerEvents: '',
      })
      .upgrade(() => {
        // Upgrade handled by schema change
      });

    this.version(9)
      .stores({
        users: '',
        learners: '++id, traineeId',
        employers: '++id, employerId, type',
        managers: '++id, userId',
        assessors: '++id, userId, assessorId',
        favourites: '',
        learnerSearch: '',
        employerSearch: '',
        staffSearch: '',
        adminDashReports: '',
        smtDashReports: '',
        healthAndSafetyDashReports: '',
      })
      .upgrade(() => {
        // Upgrade handled by schema change
      });

    this.version(10)
      .stores({
        users: '',
        learners: '++id, traineeId',
        employers: '++id, employerId, type',
        managers: '++id, userId',
        assessors: '++id, userId, assessorId',
        favourites: '',
        learnerSearch: '',
        employerSearch: '',
        staffSearch: '',
        adminDashReports: '',
        smtDashReports: '',
        healthAndSafetyDashReports: '',
        recentReportFiltersUnsaved: '++id',
        searchHistory: '',
      })
      .upgrade(() => {
        // Upgrade handled by schema change
      });

    this.version(11)
      .stores({
        users: '',
        learners: '++id, traineeId',
        employers: '++id, employerId, type',
        managers: '++id, userId',
        assessors: '++id, userId, assessorId',
        favourites: '',
        learnerSearch: '',
        employerSearch: '',
        staffSearch: '',
        adminDashReports: '',
        smtDashReports: '',
        healthAndSafetyDashReports: '',
        recentReportFiltersUnsaved: '++id',
        searchHistory: '',
        milestones: '++id, traineeId',
        progress: '++id, traineeId',
      })
      .upgrade(() => {
        // Upgrade handled by schema change
      });

    this.version(12)
      .stores({
        users: '',
        learners: '++id, traineeId',
        employers: '++id, employerId, type',
        managers: '++id, userId',
        assessors: '++id, userId, assessorId',
        favourites: '',
        learnerSearch: '',
        employerSearch: '',
        staffSearch: '',
        adminDashReports: '',
        smtDashReports: '',
        healthAndSafetyDashReports: '',
        recentReportFiltersUnsaved: '++id',
        searchHistory: '',
        milestones: '++id, traineeId',
        progress: '++id, traineeId',
        favouriteLearner: '',
      })
      .upgrade(() => {
        // Upgrade handled by schema change
      });

    this.version(13)
      .stores({
        users: '',
        permission: '',
        learners: '++id, traineeId',
        employers: '++id, employerId, type',
        managers: '++id, userId',
        assessors: '++id, userId, assessorId',
        favourites: '',
        learnerSearch: '',
        employerSearch: '',
        staffSearch: '',
        adminDashReports: '',
        smtDashReports: '',
        healthAndSafetyDashReports: '',
        recentReportFiltersUnsaved: '++id',
        searchHistory: '',
        milestones: '++id, traineeId',
        progress: '++id, traineeId',
        favouriteLearner: '',
      })
      .upgrade(() => {
        // Upgrade handled by schema change
      });

    this.version(14)
      .stores({
        users: '',
        permission: '',
        learners: '++id, traineeId',
        employers: '++id, employerId, type',
        managers: '++id, userId',
        assessors: '++id, userId, assessorId',
        favourites: '',
        learnerSearch: '',
        employerSearch: '',
        staffSearch: '',
        adminDashReports: '',
        smtDashReports: '',
        healthAndSafetyDashReports: '',
        recentReportFiltersUnsaved: '++id',
        searchHistory: '',
        milestones: '++id, traineeId',
        progress: '++id, traineeId',
        favouriteLearner: '',
      })
      .upgrade(() => {
        // Upgrade handled by schema change
      });

    this.version(15)
      .stores({
        users: '',
        permission: '',
        learners: '++id, traineeId',
        employers: '++id, employerId, type',
        managers: '++id, userId',
        assessors: '++id, userId, assessorId',
        favourites: '',
        learnerSearch: '',
        employerSearch: '',
        staffSearch: '',
        adminDashReports: '',
        smtDashReports: '',
        healthAndSafetyDashReports: '',
        recentReportFiltersUnsaved: '++id',
        searchHistory: '',
        milestones: '++id, traineeId',
        progress: '++id, traineeId',
        favouriteLearner: '',
      })
      .upgrade(() => {
        // Upgrade handled by schema change
      });

    this.version(16)
      .stores({
        users: '',
        permission: '',
        learners: '++id, traineeId',
        employers: '++id, employerId, type',
        managers: '++id, userId',
        assessors: '++id, userId, assessorId',
        favourites: '',
        learnerSearch: '',
        employerSearch: '',
        search: '',
        staffSearch: '',
        adminDashReports: '',
        smtDashReports: '',
        healthAndSafetyDashReports: '',
        recentReportFiltersUnsaved: '++id',
        searchHistory: '',
        milestones: '++id, traineeId',
        progress: '++id, traineeId',
        favouriteLearner: '',
      })
      .upgrade(() => {
        // Upgrade handled by schema change
      });

    this.version(17)
      .stores({
        attendance: '',
        users: '',
        permission: '',
        learners: '++id, traineeId',
        employers: '++id, employerId, type',
        managers: '++id, userId',
        assessors: '++id, userId, assessorId',
        favourites: '',
        learnerSearch: '',
        employerSearch: '',
        search: '',
        staffSearch: '',
        adminDashReports: '',
        smtDashReports: '',
        healthAndSafetyDashReports: '',
        recentReportFiltersUnsaved: '++id',
        searchHistory: '',
        milestones: '++id, traineeId',
        progress: '++id, traineeId',
        favouriteLearner: '',
      })
      .upgrade(() => {
        // Upgrade handled by schema change
      });
    this.version(18)
      .stores({
        attendance: '',
        users: '',
        permission: '',
        learners: '++id, traineeId',
        employers: '++id, employerId, type',
        managers: '++id, userId',
        assessors: '++id, userId, assessorId',
        favourites: '',
        learnerSearch: '',
        employerSearch: '',
        search: '',
        staffSearch: '',
        adminDashReports: '',
        smtDashReports: '',
        healthAndSafetyDashReports: '',
        recentReportFiltersUnsaved: '++id',
        searchHistory: '',
        milestones: '++id, traineeId',
        progress: '++id, traineeId',
        favouriteLearner: '',
      })
      .upgrade(() => {
        // Upgrade handled by schema change
      });
    this.version(19)
      .stores({
        attendance: '',
        users: '',
        permission: '',
        learners: '++id, traineeId',
        employers: '++id, employerId, type',
        managers: '++id, userId',
        assessors: '++id, userId, assessorId',
        favourites: '',
        learnerSearch: '',
        employerSearch: '',
        search: '',
        staffSearch: '',
        adminDashReports: '',
        smtDashReports: '',
        healthAndSafetyDashReports: '',
        recentReportFiltersUnsaved: '++id',
        searchHistory: '',
        milestones: '++id, traineeId',
        progress: '++id, traineeId',
        favouriteLearner: '',
      })
      .upgrade(() => {
        // Upgrade handled by schema change
      });
    this.version(20)
      .stores({
        attendance: '',
        users: '',
        permission: '',
        learners: '++id, traineeId',
        employers: '++id, employerId, type',
        managers: '++id, userId',
        assessors: '++id, userId, assessorId',
        favourites: '',
        learnerSearch: '',
        employerSearch: '',
        search: '',
        staffSearch: '',
        adminDashReports: '',
        smtDashReports: '',
        healthAndSafetyDashReports: '',
        recentReportFiltersUnsaved: '++id',
        searchHistory: '',
        milestones: '++id, traineeId',
        progress: '++id, traineeId',
        favouriteLearner: '',
      })
      .upgrade(() => {
        // Upgrade handled by schema change
      });
  }
}
